import { useTranslation } from 'hooks';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLinkActive, AttachmentContainer, FileUploadComponent } from './style';

function Attachment({ onChange, error, inputProps, value }) {
  const { t } = useTranslation();

  return (
    <AttachmentContainer>
      <NavLinkActive component="p">
        {value !== '' ? value : t('label.uploadCV')}
      </NavLinkActive>
      {error ? <p style={{ color: 'red' }}>{error}</p> : null}
      <FileUploadComponent
        id="attachmentFile"
        name="attachmentFile"
        type="file"
        onChange={onChange}
        {...inputProps}
      />
    </AttachmentContainer>
  );
}

Attachment.propTypes = {
  error: PropTypes.string,
  inputProps: PropTypes.object,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default Attachment;
